import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CategoriesService } from 'core/services/categories.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { KorviuModalService } from './core/services/korviu-modal.service';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LangInterceptor } from './core/interceptors/lang.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { AuthService } from 'core/services/auth.service';
import { InvitationsService } from 'core/services/invitations.service';
import { FaqService } from 'core/services/faq.service';
import { BalanceService } from 'core/services/balance.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import { LoadingOutline } from '@ant-design/icons-angular/icons';
import { NZ_I18N, es_ES } from 'ng-zorro-antd/i18n';
import { GlobalErrorHandler } from 'core/handler/global-error-handler.handler';

const icons: IconDefinition[] = [LoadingOutline];

export const appConfig: ApplicationConfig = {
  providers: [
    AuthService,
    CategoriesService,
    { provide: NzModalService, useExisting: KorviuModalService },
    InvitationsService,
    FaqService,
    BalanceService,
    provideNzIcons(icons),
    importProvidersFrom([BrowserAnimationsModule]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json',
        useHttpBackend: true
      }
    },
    ...provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      },
      fallbackLang: 'es'
    }),
    { provide: NZ_I18N, useValue: es_ES },
    { provide: HTTP_INTERCEPTORS, useClass: LangInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
